<template>
	<div>
		<j-expendable-box class="bg5 b1 bc7 r2">
			<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">
				{{ $t("payment_info") }}
			</div>
			<payment-infos
				slot="body"
				class="p2"
				:canWrite="isEditable"
				:list="computedPaymentInfo"
				:showTitle="false"
				@removed="fetchCase"
				@added="fetchCase"
				@updated="fetchCase"
			/>
		</j-expendable-box>
	</div>
</template>

<script>
import PaymentInfos from "./PaymentInfos"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	components: {
		PaymentInfos,
		JExpendableBox
	},

	data() {
		return {
			isEditable: true
		}
	},

	computed:{
		computedPaymentInfo() {
			return this.$store.state.caseManagement?.case?.paymentInfos
		}
	},

	methods: {
		fetchCase() {
			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})
		}
	}
}
</script>
